import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Backdrop, CircularProgress, Grow, Modal } from '@material-ui/core';
import axios from 'axios';
import Config from '../../commons/config/Config.js';
import * as Utils from '../../commons/utils/Utils';

const EXTENSIONES_IMAGEN = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];

const esImagen = (adjunto) => EXTENSIONES_IMAGEN.indexOf(String(adjunto.extension || '').toLowerCase()) !== -1;

const descargarBlob = (adjuntoId) =>
	axios
		.get(Config.get('apiUrlBase') + '/adjuntos/files/' + adjuntoId, {
			headers: { 'Authorization-Token': localStorage.getItem('token') },
			responseType: 'blob',
		})
		.then((respuesta) => URL.createObjectURL(respuesta.data));

const SolicitudAdjuntosModal = ({ solicitud, onClose }) => {
	const [adjuntos, setAdjuntos] = useState([]);
	const [miniaturas, setMiniaturas] = useState({});
	const [cargando, setCargando] = useState(false);
	const [error, setError] = useState(false);

	useEffect(() => {
		if (!solicitud) return undefined;

		let vigente = true;
		const urls = [];
		setCargando(true);
		setError(false);
		setAdjuntos([]);
		setMiniaturas({});

		Utils.getData('/solicitudes/' + solicitud.id + '/adjuntos')
			.then((data) => {
				if (!vigente) return;
				const lista = data || [];
				setAdjuntos(lista);
				lista.filter(esImagen).forEach((adjunto) => {
					descargarBlob(adjunto.id)
						.then((url) => {
							urls.push(url);
							if (vigente) setMiniaturas((actuales) => Object.assign({}, actuales, { [adjunto.id]: url }));
						})
						.catch(() => {});
				});
			})
			.catch(() => {
				if (vigente) setError(true);
			})
			.finally(() => {
				if (vigente) setCargando(false);
			});

		return () => {
			vigente = false;
			urls.forEach((url) => URL.revokeObjectURL(url));
		};
	}, [solicitud && solicitud.id]);

	const abrir = (adjunto) => {
		if (miniaturas[adjunto.id]) {
			window.open(miniaturas[adjunto.id]);
			return;
		}
		descargarBlob(adjunto.id)
			.then((url) => window.open(url))
			.catch(() => {});
	};

	if (!solicitud) return null;

	return (
		<Modal open={!!solicitud} onClose={onClose} closeAfterTransition BackdropComponent={Backdrop} BackdropProps={{ timeout: 300 }}>
			<Grow in={!!solicitud}>
				<div tabIndex="-1" role="dialog">
					<div className="modal-lg modal-dialog" role="document">
						<div className="modal-content">
							<div className="modal-header bg-fleet">
								<h4 className="modal-title text-white mb-0">
									<i className="la la-paperclip align-middle icon-modal-title"></i>{' '}
									<FormattedMessage id="solicitudAdjuntosModal.titulo" defaultMessage="Adjuntos de la solicitud {numero}" values={{ numero: solicitud.numero }} />
								</h4>
								<button type="button" className="close" aria-label="Close" onClick={onClose}>
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
							<div className="modal-body modal-grey modal-mh ovf-x-hidden">
								{cargando && (
									<div className="text-center p-2">
										<CircularProgress />
									</div>
								)}
								{!cargando && error && (
									<div className="text-danger">
										<FormattedMessage id="solicitudAdjuntosModal.error" defaultMessage="No se pudieron cargar los adjuntos." />
									</div>
								)}
								{!cargando && !error && adjuntos.length === 0 && (
									<div>
										<FormattedMessage id="solicitudAdjuntosModal.vacio" defaultMessage="La solicitud no tiene adjuntos." />
									</div>
								)}
								{!cargando && !error && adjuntos.length > 0 && (
									<div className="d-flex flex-wrap">
										{adjuntos.map((adjunto) => (
											<button
												key={adjunto.id}
												type="button"
												className="btn btn-link p-1 m-1 text-center"
												style={{ width: 170 }}
												onClick={() => abrir(adjunto)}
											>
												{esImagen(adjunto) && miniaturas[adjunto.id] ? (
													<img src={miniaturas[adjunto.id]} alt={adjunto.nombre} style={{ width: 160, height: 120, objectFit: 'cover' }} />
												) : (
													<i className="la la-file-o" style={{ fontSize: 60 }}></i>
												)}
												<div className="text-truncate" style={{ fontSize: 12 }}>{adjunto.nombre}</div>
											</button>
										))}
									</div>
								)}
							</div>
							<div className="modal-footer modal-grey">
								<button type="button" className="btn btn-default btn-fleet" onClick={onClose}>
									<FormattedMessage id="solicitudAdjuntosModal.ok" defaultMessage="Ok" />
								</button>
							</div>
						</div>
					</div>
				</div>
			</Grow>
		</Modal>
	);
};

export default SolicitudAdjuntosModal;
